import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from 'const';
import { TermsOfUse } from 'containers/TermsOfUse';
import { LogoutHandler } from './LogoutHandler';

export const TermsOfUseRoutes = () => (
  <Routes>
    <Route index element={<TermsOfUse />} />
    <Route path={ROUTES.LOGOUT} element={<LogoutHandler />} />
    <Route path="*" element={<Navigate to={ROUTES.ROOT} replace />} />
  </Routes>
);
